module.exports = __webpack_public_path__ + "static/media/roboto-mono-v5-latin-300.287fb5bc.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/roboto-mono/roboto-mono-v5-latin-300.ttf
// module id = 478
// module chunks = 0